<template>
  <div class="wrapper">
    <div class="content-box">
      <ul>
        <li v-for="(item, index) in itens" :key="index">
          <div class="icon">
            <icon :description="item.icon" :size="item.size" />
          </div>
          <div class="global-text">
            <p class="title">{{item.title}}</p>
            <p>
              {{item.description}}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'complement-information',
  data() {
    return {
      itens: [
        {
          id: 1,
          title: this.$t('index.benefits.title_clients'),
          description: this.$t('index.benefits.clients'),
          icon: 'rep-clients',
          size: '28',
        },
        {
          id: 2,
          title: this.$t('index.benefits.title_schedule'),
          description: this.$t('index.benefits.schedule'),
          icon: 'rep-scadule-old',
          size: '24',
        },
        {
          id: 3,
          title: this.$t('index.benefits.title_access_level'),
          description: this.$t('index.benefits.access_level'),
          icon: 'rep-access-level',
          size: '32',
        },
        {
          id: 4,
          title: this.$t('index.benefits.title_online'),
          description: this.$t('index.benefits.online'),
          icon: 'rep-online',
          size: '32',
        },
        {
          id: 5,
          title: this.$t('index.benefits.title_products_order'),
          description: this.$t('index.benefits.products_order'),
          icon: 'rep-codebar',
          size: '28',
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .wrapper
    width: 35%
    ul
      padding-top: 12px
      li
        display: flex
        align-items: center
        margin-bottom: 20px
        padding-bottom: 12px
        position: relative
        padding: 20px 16px 0
        &:before
          width: 100%
          height: 32px
          position: absolute
          bottom: -16px
          left: 0
          border-bottom: 1px solid $brand-twoo
          z-index: -1
          transform: skew(0,-3deg)
        &:not(:last-child)
          &:before
            content: ''
        .icon
          margin-right: 12px
          order: 1
          svg
            fill: $brand-twoo
        .global-text
          margin-left: 12px
          order: 2
          .title
            font-weight: 600
            font-size: 20px
            color: $brand-twoo
          p
            text-transform: lowercase
            text-align: justify
        &:nth-child(2n+2)
          .icon
            order: 2
            margin-left: 12px
            margin-right: 0
          .global-text
            order: 1
            margin-left: 0px
            margin-right: 12px
    @media (max-width: $widthTerciary)
      width: 100%
      margin-top: 32px
</style>
